import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { State } from "redux/state";

import { TermsPage, TermsPageDispatchProps, TermsPageOwnProps, TermsPageStateProps } from "../components/TermsPage";

const mapDispatchToProps: MapDispatchToProps<TermsPageDispatchProps, TermsPageOwnProps> = (
    dispatch: Dispatch
) => {
    return {};
};

const mapStateToProps: MapStateToProps<TermsPageStateProps, TermsPageOwnProps, State> = (state: State) => ({});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TermsPage)
);
